const CommonActions = {
    UPDTE_READ_COUNT: "UPDTE_READ_COUNT",
    UPDTE_NOT_RESOLVED_COUNT: "UPDTE_NOT_RESOLVED_COUNT",
  };
  
  export default CommonActions;
  